import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { Salesunit } from './salesunit.model';
import { SalesunitPopupService } from './salesunit-popup.service';
import { SalesunitService } from './salesunit.service';
import { Contact, ContactService } from '../contact';

@Component({
    selector: 'jhi-salesunit-dialog',
    templateUrl: './salesunit-dialog.component.html'
})
export class SalesunitDialogComponent implements OnInit {

    salesunit: Salesunit;
    authorities: any[];
    isSaving: boolean;

    contacts: Contact[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private salesunitService: SalesunitService,
        private contactService: ContactService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['salesunit']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.contactService.query().subscribe(
            (res: Response) => { this.contacts = res.json(); }, (res: Response) => this.onError(res.json()));
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.salesunit.id !== undefined) {
            this.salesunitService.update(this.salesunit)
                .subscribe((res: Salesunit) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        } else {
            this.salesunitService.create(this.salesunit)
                .subscribe((res: Salesunit) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: Salesunit) {
        this.eventManager.broadcast({ name: 'salesunitListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        try {
            error.json();
        } catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    trackContactById(index: number, item: Contact) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-salesunit-popup',
    template: ''
})
export class SalesunitPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private salesunitPopupService: SalesunitPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            if ( params['id'] ) {
                this.modalRef = this.salesunitPopupService
                    .open(SalesunitDialogComponent, params['id']);
            } else {
                this.modalRef = this.salesunitPopupService
                    .open(SalesunitDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/salesunit/salesunit-dialog.component.ts